/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const pdpAddToCartBtn = document.querySelector('.template-product .product__submit__add');
  const stickyBtn = document.querySelector('.product-sticky-cta__button');

  const addStickyClassToBody = () => {
    stickyBtn.innerHTML = pdpAddToCartBtn.innerHTML;
    if (pdpAddToCartBtn.getBoundingClientRect().top < -44) {
      document.body.classList.add('sticky-add-to-cart');
    } else {
      document.body.classList.remove('sticky-add-to-cart');
    }
  }

  if (pdpAddToCartBtn) {
    window.addEventListener('scroll', () => {
      addStickyClassToBody();
    });
    addStickyClassToBody();
    stickyBtn.addEventListener('click', () => {
      pdpAddToCartBtn.click();
    });
  }

  if (window.faqEntries) {

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": window.faqEntries
    };

    const faqSchemaScript = document.createElement('script');
    faqSchemaScript.type = 'application/ld+json';
    faqSchemaScript.innerHTML = JSON.stringify(faqSchema);
    document.head.appendChild(faqSchemaScript);
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
